import { FC } from 'react'
import { AppsLink } from '@wellesley/router'
import formatEditDate from 'helpers/date/formatEditDate'
import { getPostRoute } from 'helpers/routes'
import { getPastTimestamp } from 'helpers/time'
import { Tooltip, TooltipTrigger, TooltipContent } from '@wellesley/ui'

import { THeader } from '../types'

type TimeProps = Pick<THeader, 'feed' | 'time' | 'renderMenu'>

const TimeLabel: FC<TimeProps> = ({ feed, time, renderMenu }) => (
  <Tooltip disableHoverableContent>
    <TooltipTrigger data-testid="header-time-tag">
      <AppsLink
        to={getPostRoute(feed.author, feed.id)}
        data-testid="header-time"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <p className="h-xxs flex cursor-pointer items-center text-sm hover:text-blue-500">
          {getPastTimestamp(time as string)}
        </p>
      </AppsLink>
    </TooltipTrigger>
    <TooltipContent
      theme="dark"
      size="small"
      align={renderMenu ? 'center' : 'end'}
    >
      {formatEditDate(feed.createdAt)}
    </TooltipContent>
  </Tooltip>
)

export default TimeLabel
